import { CommonModule } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DisparoService } from './disparo.service';
import { Subject, takeUntil } from 'rxjs';
import { RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AlertComponent } from "../../../alert/alert.component";
import { LoadingModalComponent } from "../../../loading-modal/loading-modal.component";
import { FireCsvComponent } from "./fire-csv/fire-csv.component";
import { FireQueueComponent } from './fire-queue/fire-queue.component';
import { FireOficialCsvComponent } from './fire-oficial-csv/fire-oficial-csv.component';
import { FireOficialListaComponent } from './fire-oficial-lista/fire-oficial-lista.component';
import { ExportFileService } from '../../../utils/export-file.service';
import { RelatorioService} from './relatorio/relatorio-service.service';
import { ListasService } from '../listas/listas.service';
import { CanaisServiceService } from '../canais/canais-service.service';
import { MessagesService } from '../messages/messages.service';
import { DisparosPipe } from './disparos.pipe';

@Component({
  selector: 'app-disparos',
  standalone: true,
  imports: [MatIconModule, CommonModule, RouterModule, ReactiveFormsModule, FormsModule, AlertComponent, LoadingModalComponent, FireCsvComponent,FireQueueComponent, FireOficialCsvComponent, FireOficialListaComponent ,DisparosPipe ],
  templateUrl: './disparos.component.html',
  styleUrls: ['./disparos.component.scss'],
  providers: [DisparoService, ExportFileService, RelatorioService, ListasService, CanaisServiceService, MessagesService, DisparosPipe]
})
export class DisparosComponent implements OnInit {

  private unsubscribe$: Subject<void> = new Subject();

  //Variables of loading and alert
  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingComponent !: LoadingModalComponent;

  //Variables of Modal new fire
  public modalNewFire: boolean = false;
  public selectedFire: boolean = false;
  public selectedTypeForm?: string;
  public countInputFile: number = 0;
  public listMessages!: Array<any>;
  public listChannels!: Array<any>;
  public isEmojiPickerVisible: boolean = false;
  public isScheduled: boolean = false;

  public selectedFiles: Array<any> = [];
  public errorMessage: string | null = null;

  public handleExt: string = 'normal';

  //Variables of list fires
  public page: number = 1;
  public listFires!: Array<any>;
  public typeFire?: string;


  constructor(private disparoService: DisparoService, private fb: FormBuilder, private relatorioService: RelatorioService, private exportFileServer: ExportFileService) {

  }

  ngOnInit() {
    this.disparoService.getDisparos(this.page).pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((response: any) => {
      this.listFires = response.retorno;
    })
  }

  public updateListDisparos() {
    this.disparoService.getDisparos(this.page).pipe(
      takeUntil(this.unsubscribe$)
    ).subscribe((response: any) => {
      this.listFires = response.retorno;
    })
  }

  //Functions of modal new fire
  public openModalNewFire() {
    this.modalNewFire = true;
    this.typeFire = '';
    this.selectedFire = false;

  }

  public closeModalNewFire() {
    this.modalNewFire = false;
    this.updateListDisparos();
  }

  public handleSelectTypeFire(type: string) {
    console.log(type);
    if (this.selectedFire && this.typeFire != type) {
      this.typeFire = type;
    } else {
      this.selectedFire = !this.selectedFire;
      this.typeFire = type;
    }

  }

  public handleSelectTypeForm(type: string) {
    this.selectedTypeForm = `${type}-${this.typeFire}`;
    console.log(this.selectedTypeForm);
  }

  public closeModalConfiguration(event: number){
    if(event === 2) {
      this.selectedTypeForm = '';
      this.closeModalNewFire();
    }
    if(event === 1){
      this.selectedTypeForm = '';
    }
  }

  //Functions the footer list fires
  public previousPage() {
    if (this.page > 1) {
      this.page--;
      console.log(this.page);
      this.updateListDisparos();
    }
  }

  public nextPage() {
    this.page++;
    console.log(this.page);
    this.updateListDisparos();
  }

  public handleStopDisparo(idDisparo: number){
    this.loadingComponent.activeLoading();
    this.disparoService.stopDisparo(idDisparo).subscribe((response: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Disparo parado com sucesso!`);
    }, (error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar parar o disparo ${error.error.status}`, 'error');
      console.log(error)
    })
  }

  public handleResendDisparo(idDisparo: number){
    this.loadingComponent.activeLoading();
    this.disparoService.resendDisparo(idDisparo).subscribe((response: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Disparo reenviado com sucesso!`);
    }, (error: any)=> {
      this.loadingComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao tentar reenviar o disparo ${error.error.status}`, 'error');
      console.log(error)
    })
  }

  public handleExportReport(idRelatorio: number): void{
    this.loadingComponent.activeLoading();
    this.relatorioService.getReport(idRelatorio).subscribe((response: any)=> {
      this.loadingComponent.inactiveLoading();
      this.exportFileServer.exportAsExcelFile(response.mensagens);
    })
  }

  public async copyDisparoId(idDisparo: number): Promise<void> {
    const text = String(idDisparo);
    let copied = false;
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        copied = true;
      }
    } catch (error) {
      console.error('Erro ao copiar ID do disparo', error);
    }

    if (!copied) {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        copied = document.execCommand('copy');
      } catch (error) {
        console.error('Erro ao copiar ID do disparo (fallback)', error);
      } finally {
        document.body.removeChild(textarea);
      }
    }

    if (copied) {
      this.alertComponent.showAlert('ID do disparo copiado!', 'success');
    } else {
      this.alertComponent.showAlert('Nao foi possivel copiar o ID do disparo.', 'error');
    }
  }
}
